import { Box } from '@mui/material';
import { useField } from 'formik';

import { DisplayCurrency } from 'src/components';
import { DisplayCurrencyStyleVariants } from 'src/components/DisplayCurrency';
import { useCurrency } from 'src/hooks/useCurrency';

function TransactionChargeValueNonEditable({ fieldName }) {
    const [{ value }] = useField(fieldName);
    const { currencySymbol } = useCurrency();

    if (!Number.isFinite(value)) {
        return <Box sx={{ width: '100%', height: '100%' }} />;
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <DisplayCurrency
                currencyAmount={value}
                disableStyling={false}
                centsAmount={undefined}
                usersCurrency={currencySymbol}
                styleVariant={DisplayCurrencyStyleVariants.INPUT}
            />
        </Box>
    );
}

export default TransactionChargeValueNonEditable;
